// extracted by mini-css-extract-plugin
export default {"isActive":"ConstructorContent_isActive__p1OU5"};